import React from "react";
import 'chart.js/auto';
import { Line } from "react-chartjs-2";
import { primaryColor } from "../constants/color";
interface P {
    lables: string[];
    data: string[];
}
export default function LineChart(props: P) {
    const data = {
        labels: props.lables,
        datasets: [
            {
                label: "Sales",
                data: props.data,
                fill: true,
                backgroundColor: "rgba(133, 175, 255,0.2)",
                borderColor: primaryColor
            },
        ]
    };
    const options = {
        title: {
            display: true,
            text: 'Sale Chart'
        },
        legend: {
            display: true,
            position: "right"
        },
        elements: {
            arc: {
                borderWidth: 0
            }
        },

    };
    return (
        <div>
            <Line data={data} options={options} />
        </div>
    );
}
